var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play",
    transform: "translate(-1355 -5489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_8703",
    "data-name": "Path 8703",
    transform: "translate(1374 5493) rotate(90)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.391,2.177a2,2,0,0,1,3.217,0l4.036,5.463a2,2,0,0,1-1.609,3.188H3.964A2,2,0,0,1,2.355,7.641Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.999998569488525 2.965892791748047 C 7.907928466796875 2.965892791748047 7.777388572692871 2.994052886962891 7.678268432617188 3.128212928771973 L 3.642358779907227 8.591342926025391 C 3.521438598632812 8.755022048950195 3.556368827819824 8.908912658691406 3.606958389282227 9.00919246673584 C 3.657558441162109 9.109472274780273 3.760578155517578 9.229012489318848 3.964078903198242 9.229012489318848 L 12.03590869903564 9.229012489318848 C 12.23940849304199 9.229012489318848 12.34243869781494 9.109472274780273 12.39303874969482 9.00919246673584 C 12.44362831115723 8.908912658691406 12.47855854034424 8.755012512207031 12.35763835906982 8.59133243560791 L 8.321718215942383 3.128202438354492 C 8.22260856628418 2.994052886962891 8.092068672180176 2.965892791748047 7.999998569488525 2.965892791748047 M 7.999998569488525 1.365889549255371 C 8.604457855224609 1.365889549255371 9.208918571472168 1.636427879333496 9.608638763427734 2.177502632141113 L 13.6445484161377 7.640622615814209 C 14.61988830566406 8.96085262298584 13.67734909057617 10.82901287078857 12.03590869903564 10.82901287078857 L 3.964078903198242 10.82901287078857 C 2.322649002075195 10.82901287078857 1.380108833312988 8.96085262298584 2.355448722839355 7.640622615814209 L 6.391358375549316 2.177502632141113 C 6.791078567504883 1.636427879333496 7.395538330078125 1.365889549255371 7.999998569488525 1.365889549255371 Z",
    stroke: "none",
    fill: "#ff411a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_8704",
    "data-name": "Path 8704",
    transform: "translate(1355 5489)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12 1.700000762939453 C 6.320560455322266 1.700000762939453 1.700000762939453 6.320560455322266 1.700000762939453 12 C 1.700000762939453 17.67943954467773 6.320560455322266 22.29999923706055 12 22.29999923706055 C 17.67943954467773 22.29999923706055 22.29999923706055 17.67943954467773 22.29999923706055 12 C 22.29999923706055 6.320560455322266 17.67943954467773 1.700000762939453 12 1.700000762939453 M 12 0 C 18.62742042541504 0 24 5.372579574584961 24 12 C 24 18.62742042541504 18.62742042541504 24 12 24 C 5.372579574584961 24 0 18.62742042541504 0 12 C 0 5.372579574584961 5.372579574584961 0 12 0 Z",
    stroke: "none",
    fill: "#ff411a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a45b008c.svg";
export { ForwardRef as ReactComponent };